<!-- @format -->
<template>
  <div class="base-kinofinder" v-if="$config.kinoservice.display" :class="$mq">
    <ul :class="$mq">
      <!-- <li :class="$mq">
        <a
          :class="$mq"
          href="#"
          @mouseover="kinofinder_hover = true"
          @mouseleave="kinofinder_hover = false"
          >{{ $config.kinoservice.finder_text }}</a
        >
        <div
          class="base-kinofinder__btns"
          :class="{ hovered: kinofinder_hover }"
          @mouseover="kinofinder_hover = true"
          @mouseleave="kinofinder_hover = false"
        >
          <a
            target="_blank"
            :href="$config.kinoservice.finder + $config.kinoservice.slug"
            class="base-kinofinder__item share__de"
            >Deutschland
          </a>
          <a
            href="https://www.falter.at/kino/921345/wagner-bayreuth-und-der-rest-der-welt?date=2022-02-12&region=kärnten"
            target="_blank"
            class="base-kinofinder__item share__at"
          >
            Österreich
          </a>
        </div>
      </li>
      <li :class="$mq" v-if="$config.kinoservice.alert_text !== ''">
        <a
          :class="$mq"
          :href="$config.kinoservice.alert + $config.kinoservice.id"
          target="_blank"
          >{{ $config.kinoservice.alert_text }}</a
        >
      </li> -->
      <mq-layout mq="lg+">
        <li class="share" v-if="$config.kinoservice.share !== ''">
          <a href="#" @mouseover="hover = true" @mouseleave="hover = false"
            >Teilen</a
          >
          <div
            class="share__btns"
            :class="{ hovered: hover }"
            @mouseover="hover = true"
            @mouseleave="hover = false"
          >
            <a
              target="_blank"
              :href="`https://www.facebook.com/sharer/sharer.php?u=${$config.url}`"
              class="share__item share__fb"
              ><img src="@/assets/images/social/fb_plain.png" alt="" />
            </a>
            <a
              :href="`https://twitter.com/intent/tweet?text=${$config.twitter.text}`"
              target="_blank"
              class="share__item share__twitter"
            >
              <img src="@/assets/images/social/twitter_plain.png" alt="" />
            </a>
          </div>
        </li>
      </mq-layout>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hover: false,
      kinofinder_hover: false,
    }
  },
}
</script>

<style lang="scss">
.hovered {
  transform: translateY(var(--height-header));
}

.base-kinofinder {
  position: relative;
  height: var(--height-header);
  &.sm,
  &.md {
    height: auto;
  }
  &__btns {
    position: absolute;
    z-index: 99999;
    left: 0;
    top: -59px;
    background-color: #fe1521;
    height: var(--height-header);
    display: flex;
    flex-direction: row;
    transition: transform 0.3s ease-in-out;

    .base-kinofinder__item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }
    .share__de {
      padding-inline: 10px;
      &:hover {
        color: white;
        background-color: darken(#fe1521, 10%);
      }
    }
    .share__at {
      padding-inline: 10px;
      &:hover {
        color: white;
        background-color: darken(#fe1521, 10%);
      }
    }
  }
  ul {
    position: relative;
    margin: 0;
    padding: 0;
    text-align: center;
    list-style-type: none;
    line-height: var(--lh-header);
    display: flex;
    &.sm,
    &.md {
      flex-direction: column;
    }

    .hovered {
      transform: translateY(var(--height-header));
    }

    .share {
      position: relative;
      &__btns {
        position: absolute;
        padding-left: 10px;
        top: -59px;
        right: -50px;
        height: var(--height-header);
        display: flex;
        flex-direction: row;
        transition: transform 0.3s ease-in-out;
        width: 120px;
        .share__item {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
        }
        .share__fb {
          background-color: $facebook;
          &:hover {
            background-color: darken($facebook, 5%);
          }
        }
        .share__twitter {
          background-color: $twitter;
          &:hover {
            background-color: darken($twitter, 5%);
          }
        }
      }
    }
    li {
      height: var(--height-header);
      display: inline-block;
      text-align: left;
      &.sm,
      &.md {
        height: auto;
      }
      a {
        text-decoration: none;
        text-transform: uppercase;
        height: var(--height-header);
        line-height: var(--height-header);
        color: var(--clr-link-header);
        /* $min_width: 1024px;
        $max_width: 2560px;
        $min_font: 16px;
        $max_font: $header-fontsize;
        @include fluid-type($min_width, $max_width, $min_font, $max_font); */
        &:hover {
          color: var(--clr-link-hover-header);
        }
        &.sm,
        &.md {
          font-weight: 600;
          margin-bottom: 10px;
          /* $min_width: 300px;
          $max_width: 1023px;
          $min_font: 20px;
          $max_font: 38px;
          @include fluid-type($min_width, $max_width, $min_font, $max_font); */
        }
      }
      &:not(:last-child) {
        padding-right: var(--p-link-header);
      }
    }
  }
}
</style>
